// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, find } from 'lodash';

import io from 'socket.io-client';

// components
import NavColumn from './../admin/NavColumn';
import ScrollColumn from './../../common/components/ScrollColumn';
import ApplicantManager from './r_ApplicantManager';

// utility
import queryify from '../../lib/queryify';

// redux interactions
import * as asyncActionCreator from '../../redux/actionCreators/async';
import * as syncActionCreator from '../../redux/actionCreators/sync';

const socket = io(process.env.BASE_URL);


@connect((store, props) => ({
  user: store.user,
  staticData: store.staticData,
  applicantsLoaded: !!Object.keys(store.admin.applicants).reduce((prev, current) => prev + current.length, 0),
  applicantStatusGroups: store.user.statusGroups,
  applicants: store.admin.applicants,
  route: {
    params: props.params,
    query: props.location.query
  } // actually being from from react-redux-router to regular props
}))
export default class AdminDashboard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    route: PropTypes.object,
    location: PropTypes.object,
    query: PropTypes.object,
    params: PropTypes.object, // comes from react-redux-router
    user: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    // register sockets
    this.onSearch();
    socket.on('new applicant', (data) => this.incomingApplicant(data));
  }

  componentWillUnmount() {
  }

  onSearch(terms = [], filters = {}) {
    this.props.dispatch(asyncActionCreator.search(terms, filters));
  }

  onPageChange(terms = [], filters = {}, group, skip, sortBy) {
    this.props.dispatch(asyncActionCreator.goToPage(terms, filters, group, skip, sortBy));
  }

  incomingApplicant(applicant) {
    const qsUID = get(find(this.props.staticData.qualifyingSpecialists, (q) => q.employeeId === applicant.profile.qualifyingSpecialistId), 'id');

    // For QS we only add the new applicant with QS matched.
    if (!!~this.props.user.roles.indexOf('Qualifying Specialist') && this.props.user.id !== qsUID) {
      return;
    }
    this.props.dispatch(syncActionCreator.addApplicantAdmin(applicant));
  }

  expandCard(applicantEmail, detail = false) {
    if (detail === true) {
      this.props.dispatch(push(`/admin/${this.props.route.params.navColumnState}/${applicantEmail}/Profile/?detail=1`));
    }
    else {
      this.props.dispatch(push(`/admin/${this.props.route.params.navColumnState}/${applicantEmail}${queryify(this.props.route.query)}`));
    }
  }

  render() {
    return (
      <div className='admin-content-container clearfix'>
        {this.props.route.params.navColumnState === 'Prospect'
        &&
        <ScrollColumn
          navGroups={['Company_Info', 'Contact_Info', 'Preliminary_Info', 'Inquiry_Reason']}
          title={'Add New'}
        />
        ||
        <NavColumn
          navColumnState={this.props.route.params.navColumnState}
          navGroups={this.props.applicantStatusGroups}
          navItems={this.props.applicants.search}
          baseUrl={'/admin'}
          title={'Candidates'}
        />
        }
        <ApplicantManager
          expandCard={::this.expandCard}
          selectedEmail={this.props.route.params.email}
          navColumnState={this.props.route.params.navColumnState}
          onSearch={::this.onSearch}
          onPageChange={::this.onPageChange}
        />
        { // allow for expanded card
          this.props.children
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/index.js